<template>
  <div class="role-auth">
    <ul class="role-auth-title">
      <li
        v-for="(item, index) in headerList"
        :key="index"
        :class="{ active: roleType == index }"
        @click="chooseType(index)">
        {{ item }}
      </li>
    </ul>
    <div class="role-auth-bottom">
      <systemRole v-if="roleType == '0'" ref="systemRole" @setLoading="setLoading" />
      <projectRole v-if="roleType == '1'" ref="projectRole" :curOption="curOption" @setLoading="setLoading" />
      <permissionDocument v-if="roleType == '2'" />
      <allprjPrivi v-if="roleType == '3'" @setRoleType="setRoleType" />
    </div>
  </div>
</template>
<script>
import systemRole from '@/CommonDP/pages/mainMg/settings/permission/components/systemRole.vue';
import projectRole from '@/CommonDP/pages/mainMg/settings/permission/components/projectRole.vue';
import permissionDocument from '@/CommonDP/pages/mainMg/settings/permission/components/permissionDocument.vue';
import allprjPrivi from '@/CommonDP/pages/mainMg/settings/permission/components/allprjPrivi.vue';
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  name: "RolePowerConfig",
  components: {
    systemRole,
    projectRole,
    permissionDocument,
    allprjPrivi
  },
  data() {
    return {
      headerList: ["系统角色", "项目角色", "文档权限", "所有项目权限"],
      loading: false,
      roleType: 0,
      curOption: {
        roleID: "",
        roleName: ""
      }
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.manageGlobalParams();
  },

  methods: {
    manageGlobalParams() {
      const header = globalParams.get("setting.permission.hidesomeHeader");
      if (header) {
        this.headerList = this.headerList.slice(0, 3);
      }
    },
    // 切换系统角色和项目角色
    async chooseType(key) {
      this.curOption.roleID = '';
      this.curOption.roleName = '';
      if (this.loading) return this.$warn("请等待加载完毕");
      this.roleType = key;
      if (key === 2 || key === 3) return; // 2 3是单独引入的组件,自己内部处理逻辑
      this.loading = true;
      // this.$nextTick(() => {
      //   if (key === 0) {
      //     this.$refs.systemRole.getRoleList(key);
      //   } else if (key === 1) {
      //     this.$refs.projectRole.getRoleList(key);
      //   }
      // });
    },
    setLoading() {
      this.loading = false;
    },
    async setRoleType(data) {
      this.roleType = '1';
      this.curOption.roleID = data.roleID;
      this.curOption.roleName = data.roleName;
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss" />
